module.exports = __webpack_public_path__ + "assets/score-min.a39ed5ab7dcd665045c50dcc95452b37.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Aplifit/score-min.jpg
 ** module id = 396
 ** module chunks = 0
 **/